import React from "react";
import styled from 'styled-components';
import InputSubTitleClaroSocio from '../../../molecules/InputSubtitleClaroSocio';
import InputTitleClaroSocio from '../../../molecules/InputTitleClaroSocio';
import ClaroImage from '../../../molecules/ClaroImage'
import ClaroInputField from "../../../atoms/ClaroInputField";
import SearsInputField from "../../../atoms/SearsInputField";
import ClaroDiv from "../../../atoms/ClaroDiv";
import ClaroInputButton from "../../../atoms/ClaroInputButton"
import { validationStyles } from '../utils/index'

const Container = styled.div`
    width: 100%%;
    background: ${props => props.background ? props.background : "#fff"};
    margin: 2%;
`;

class DescriptionInputClaroSocio extends React.Component {

    constructor(props, context){
        super(props, context)
        this.state = {
            //value: this.props.input.field.input.value
            isFocused: false
        }
    }

    componentDidMount() {
        //console.log(this.props.input.field.input, "en el defaultinput" );
    }

    render(){

        let  validation = validationStyles(this.props.isValid, this.props.isContainerTelcel, this.props.isClaroPartner);
        const styles = {
            "color": validation.validInvalidColor,
            "borderBottom": this.props.isContainerTelcel && this.state.isFocused && this.props.isValid ? "1px solid #0071d1" : validation.borderValidInvalidColor,
            //"border": "5px solid red"
        }
        let id = "pagoDeServicios_" + this.props.input.id + "_" + this.props.serviceName;
        return(
            <Container background={this.props.isContainerTelcel && !this.props.isClaroPartner ? "#fff" : undefined}>
                <InputTitleClaroSocio 
                    {...this.props.input.title} 
                    type={this.props.input.type} 
                    handleClickTooltip = {this.props.handleClickTooltip} 
                    logicType={this.props.logicType}
                    isContainerTelcel={this.props.isContainerTelcel}
                    isClaroPartner={this.props.isClaroPartner}
                    isFocused={this.state.isFocused}
                />
                <ClaroDiv  {...styles}>
                    {
                        (this.props.logicType == "sears")?
                            <SearsInputField 
                                {...styles} 
                                value={this.props.value} 
                                onChange={(e) =>{this.props.handleInputChange(e, this.props.input.type)}}
                                name={this.props.input.field.input.name}
                                placeholder={this.props.input.field.input.placeholder}
                                id = {id}
                                type={this.props.input.field.input.type}
                                onFocus={this.props.handleClickScroll}
                            />:
                            <ClaroInputField 
                                {...styles} 
                                value={this.props.value} 
                                onChange={(e) =>{this.props.handleInputChange(e, this.props.input.type)}}
                                name={this.props.input.field.input.name}
                                placeholder={this.props.input.field.input.placeholder}
                                id = {id}
                                type={this.props.input.field.input.type}
                                onFocus={()=>{this.props.handleClickScroll,this.setState({isFocused: true})}}
                                onBlur={()=>this.setState({isFocused: false})}
                                phColor= {this.props.isContainerTelcel && !this.props.isClaroPartner ? "#757575" : "#c4c4c4"}
                                fontFamily = {this.props.isContainerTelcel && !this.props.isClaroPartner ? "AMX-Regular" : undefined}
                                fontSize = {this.props.isContainerTelcel && !this.props.isClaroPartner ? "14px" : undefined}
                            />
                    }
                    {
                        this.props.input.field.button ? (
                            <ClaroInputButton 
                                borderBottom={validation.borderValidInvalidColor} 
                                {...this.props.input.field.button}
                                onClick= {(e) =>{this.props.handleInputButtonFunction(e, this.props.input.type)}}
                            >
                                <ClaroImage {...this.props.input.field.button} isClaroPartner={true} />
                            </ClaroInputButton>
                        ):(<></>)
                    }
                </ClaroDiv>
                <InputSubTitleClaroSocio {...this.props.input.subTitle} type={this.props.input.type} />
            </Container>
        )
    }
}

export default DescriptionInputClaroSocio;